import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../../../Login/selectors/permissionSelector";
import { OfficeHierarchyOrgChartTab } from "./OfficeHierarchyOrgChartTab";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const OfficeHierarchyOrgCharts = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const userPermissions = useRecoilValue(permissionsSelector);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const currentTabs = OfficeHierarchyOrgChartTab.filter((tabs) =>
    userPermissions.includes(tabs.permission)
  );
  const defaultTab = currentTabs.findIndex((c) => pathname.includes(c.to));
  const path = currentTabs.findIndex((c) => pathname === c.to);
  const getPath = localStorage.getItem("path");
  const onCloseIndex = currentTabs.findIndex((c) => getPath === c.to);

  useEffect(() => {
    if (defaultTab < 0) {
      if (pathname === "/") {
        setSelectedIndex(onCloseIndex);
      } else {
        history.push(currentTabs[0]?.to);
        setSelectedIndex(0);
      }
    } else {
      if (selectedIndex > 0) {
        if (selectedIndex === path) {
          setSelectedIndex(selectedIndex);
        } else {
          setSelectedIndex(defaultTab);
        }
      } else {
        setSelectedIndex(path);
      }
    }
  }, []);

  return (
    <div>
      <Router>
        <div>
          <div className="hidden sm:block">
            <div className="ml-7 border-gray-200">
              <nav className="flex" aria-label="Tabs">
                {currentTabs.map((tab, index) => (
                  <Link
                    key={index}
                    onClick={() => {
                      setSelectedIndex(index);
                    }}
                    to={tab.to}
                    className={classNames(
                      index === selectedIndex
                        ? " bg-LightWhite border px-8 border-gary-500 text-secondary border-b-2 items-center place-content-center border-b-secondary"
                        : "border px-8 text-gray-500 hover:text-gray-700 items-center place-content-center hover:border-gray-300",
                      "whitespace-nowrap py-4 px-8  border-b-2 font-medium text-md"
                    )}
                  >
                    {tab.label}
                  </Link>
                ))}
              </nav>
            </div>
            {currentTabs.map((main, index) => {
              return (
                <Switch key={index}>
                  <Route path={main.to} exact component={main.component} />
                </Switch>
              );
            })}
          </div>
        </div>
      </Router>
    </div>
  );
};

export default OfficeHierarchyOrgCharts;
